
import Vue from "vue"
import {Prop} from "vue-property-decorator"
import Component from "vue-class-component"
import {DateRangeSelector} from "@/DateRangeSelector"
import {DateRangeService} from "@/DateRangeService"

@Component
export default class DateRangeSelect extends Vue {
  @Prop()
  dateRangeSelector: DateRangeSelector

  @Prop()
  disable: boolean

  loadingModel = {label: DateRangeService.DEFAULT_OPTION_LABEL}
}
